import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBell = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 18 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15.4167 10.954V7.66683C15.4167 4.71791 13.4138 2.23375 10.7004 1.48666C10.4318 0.810163 9.7755 0.333496 9 0.333496C8.2245 0.333496 7.56817 0.810163 7.29958 1.48666C4.58625 2.23466 2.58333 4.71791 2.58333 7.66683V10.954L1.01858 12.5187C0.84625 12.6902 0.75 12.923 0.75 13.1668V15.0002C0.75 15.5071 1.15975 15.9168 1.66667 15.9168H16.3333C16.8402 15.9168 17.25 15.5071 17.25 15.0002V13.1668C17.25 12.923 17.1537 12.6902 16.9814 12.5187L15.4167 10.954ZM15.4167 14.0835H2.58337V13.5463L4.14812 11.9816C4.32046 11.8102 4.41671 11.5773 4.41671 11.3335V7.66683C4.41671 5.13958 6.47279 3.0835 9.00004 3.0835C11.5273 3.0835 13.5834 5.13958 13.5834 7.66683V11.3335C13.5834 11.5773 13.6796 11.8102 13.852 11.9816L15.4167 13.5463V14.0835ZM9.00004 18.6668C10.2018 18.6668 11.2065 17.9023 11.5832 16.8335H6.41687C6.79362 17.9023 7.79829 18.6668 9.00004 18.6668Z",
		fill: "currentColor"
	})
});
export { SvgBell as ReactComponent };
